import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Permissions } from '../../config';
import { Add, AddAlert } from '@mui/icons-material';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import SnackbarCustom from '../../components/Snackbar/Snackbar.js';
import SparaTitle from 'components/SparaTitle/SparaTitle';
import SparaButton from 'components/SparaButton/SparaButton';

import { deleteCompanyUser } from '../../store/actions/companyUser';
import { useCompanyUsersForRole } from '../../lib/api';
import CompanyUsersTable from './companyUsersTable';

const CompanyUser = ({ t }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { status, message, type } = useSelector((state) => state.companyUser.notification);

    const userStore = JSON.parse(localStorage.getItem('user') || '{}');
    const userPermission = userStore.permission ?? [];
    const roles = userStore.roles ?? [];
    const isAdmin = roles.includes('super_admin');

    const { companyUsers, loading } = useCompanyUsersForRole();

    const handleUpdate = (user) => {
        if (isAdmin) {
            navigate(`/user/${user.torgid_user_id}`);
        }
    };

    const handleDelete = (data) => {
        dispatch(deleteCompanyUser({ ...data }));
    };

    const canCreate = userPermission.includes(Permissions.COMPANY_USER_CREATE);

    const handleCreate = () => {
        if (isAdmin) {
            navigate('/user/new');
        }
    };

    return (
        <GridContainer>
            <SnackbarCustom
                place="br"
                icon={AddAlert}
                color={type === 'success' ? 'success' : 'warning'}
                message={message}
                open={status}
            />
            <GridItem xs={12}>
                <SparaTitle
                    title={t('menu.company_users')}
                    subtitle={!isAdmin ? t('company_user.page_subtitle') : undefined}
                    rightComponent={
                        canCreate && (
                            <SparaButton color="primary" icon={Add} onClick={handleCreate}>
                                {t('company_user.add_new_user')}
                            </SparaButton>
                        )
                    }
                />
                <Card style={{ margin: '0px' }}>
                    <CardBody>
                        <CompanyUsersTable
                            data={companyUsers}
                            loading={loading}
                            onUpdate={handleUpdate}
                            onDelete={handleDelete}
                        />
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
};

export default withTranslation('', { withRef: true })(CompanyUser);
